export default "__VITE_ASSET__DOrLQyxZ__"